
import React from "react";
import { toast } from "react-toastify";
import useApi from "../useApi";

interface BillingCycle {
  billingCycleName: string;
  statuses: {
    Billable: number;
    Billed: number;
    Running: number;
  };
}

interface BillingCyclesResponse {
  status: string;
  data: BillingCycle[];
}

const useBillingCycles = () => {
  const [billingCycles, setBillingCycles] = React.useState<BillingCycle[]>([]);
  const [loading, setLoading] = React.useState(false);

  const { makeApiCall } = useApi({
    url: "/rtm/dashboard/billing/status",
    method: "GET",
  });

  const getBillingCycles = async () => {
    setLoading(true);
    try {
      const { response, error } = await makeApiCall<undefined, BillingCyclesResponse>();

      if (response?.status === "success") {
        setBillingCycles(response.data);
      } else if (error) {
        toast.error("Failed to fetch billing cycles");
      }
    } catch (err) {
      toast.error("An error occurred while fetching billing cycles");
    } finally {
      setLoading(false);
    }
  };

  return {
    billingCycles,
    getBillingCycles,
    loading,
  };
};

export default useBillingCycles;